/*
window.addEventListener('load', function () {
  var PromotionsPopupSection = (function () {
    function PromotionsPopupSection(element) {

      var element = element;
      var options = JSON.parse(element.getAttribute('data-section-settings'));
      var cookie_enabled = options['show_popup'];
      var popup = document.cookie.indexOf('themePopup=open') > 0;
	     console.log('popup',popup);
      // If the popup has been already displayed, we do not display it
      //debugger
       try {
        if (popup) {
          return false;
        }
        if (window.location.hash === '#newsletter-popup') {
          _openPopup();
        } else if ((!options['showOnlyOnce'] || options['showOnlyOnce']) && cookie_enabled) {
          setTimeout(
            _openPopup()
          , options['apparitionDelay'] * 1000);
        }
      } catch (error) {
        console.log('error:'+error);
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      if (cookie_enabled) {
        spu_createCookie('themePopup','open',6)
      }

      function spu_createCookie(name, value, hours) {
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime()+(hours*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        } else {
            var expires = "";
        }

        document.cookie = name+"="+value+expires+"; path=/";
      }

      _attachListeners();

      function onUnload() {
          this.delegateElement.off();
      };
      function onSelect() {
        _openPopup();
      };
      function onDeselect() {
        _closePopup();
      };
      function _attachListeners() {
        element.querySelector('[data-action="close-popup"]').addEventListener('click', _closePopup);
      };
      function _openPopup() {
        //window.addEventListener('load',function(){
          element.setAttribute('aria-hidden', 'false');
        //})
      };
      function _closePopup() {
        element.setAttribute('aria-hidden', 'true');
      }
    }

    return PromotionsPopupSection;

  })();

  if (document.getElementsByClassName('NewsletterPopup')[0]) {
    PromotionsPopupSection(document.getElementsByClassName('NewsletterPopup')[0])
  }

});
*/

/*
  Adding Event Listener to All Add buttons to get the section id we want to fetch
  Then we will call the function that fetch that section and replace the content
*/

function renderProductBuyButtonsNEW(respond, target){
  var section_id = target.getAttribute('data-section-id')
  var terget_section = respond.sections[section_id]
  const html = new DOMParser().parseFromString(terget_section, 'text/html');
  console.log('Section content: ', html)
  // Getting New section buttons from the request HTML
  const newSectionButtons = html.querySelectorAll(`[data-section-id="${section_id}"] .buy-buttons-js`)
  // Getting the current section buttons
  const oldSectionButtons = document.querySelectorAll(`[data-section-id="${section_id}"] .buy-buttons-js`)
  console.log('newSectionButtons: ',newSectionButtons)
  console.log('oldSectionButtons: ',oldSectionButtons)
  // Replacing the HTML content
  oldSectionButtons.forEach((button, index)=>{
    button.innerHTML = newSectionButtons[index].innerHTML
  })
}

window.renderButtonsNew = renderProductBuyButtonsNEW;

/*
  Function to rerender the (Product / Collection ) template buy buttons snippet
  When we add product to the cart
*/
function renderProductBuyButtons(respond){
  var productHandle = respond.items[0].handle
  // console.log('productHandle:', productHandle)
  /*
    const parser = new DOMParser();
    const doc = parser.parseFromString(respond.sections['main-product'], 'text/html');
    const productSection = doc.querySelector('section')
    var isSecret = productSection.getAttribute('data-is-secret')
    console.log('productSection: ', productSection)
    // console.log('isSecret: ', isSecret)
    const oldSection = document.querySelector('.product-id');
    console.log('oldSection: ', oldSection)
    oldSection.innerHTML = productSection.innerHTML
  */
  if (document.querySelector(`[data-section-type="product_page"]`)) {
    console.log('We are in Product page')
    fetch(`/products/${productHandle}`)
    .then(response => response.text()) // Use response.text() instead of response.json() to retrieve the liquid code as a string
    .then(data => {
      // console.log('data: ', data)
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
  
      // Select any child element and access its innerHTML
      // var isSecret = document.querySelector('.product-id').getAttribute('data-is-secret')

      const newBuyButtons = doc.querySelector('.buy-buttons-js'); // Replace '.child-element' with the appropriate selector
      const innerHTML = newBuyButtons.innerHTML;
    
      //console.log(innerHTML); // Output the innerHTML of the selected child element
        
      const buyButtonsDiv = document.querySelector('.buy-buttons-js'); // Replace '.buy-buttons' with the actual class name of the div
    
      // Replace the contents of the div with the liquid code
      buyButtonsDiv.innerHTML = innerHTML;
      
      var isSecret = document.querySelector(`[data-section-type="product_page"]`).getAttribute('data-is-secret')
      if (isSecret == 'true'){
        console.log('product is secret')
      }else{
        console.log('product is NOT secret')
      }
      
    })
    .catch(error => console.error('Error fetching product:', error));
  }
  else if (document.querySelector(`[data-section-type="collection_page"]`)){
    console.log('We are in Collection page')
    console.log(window.location.href)
    fetch(window.location.href)
    .then(response => response.text()) // Use response.text() instead of response.json() to retrieve the liquid code as a string
    .then(data => {
      // console.log('data collection: ', data)
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      
      var isSecret = document.querySelector(`[data-is-secret]`).getAttribute('data-is-secret')
        const newBuyButtons = doc.querySelectorAll('.purchase');
        const oldBuyButtons = document.querySelectorAll('.purchase');
  
        for (let i = 0; i < oldBuyButtons.length; i++) {
          oldBuyButtons[i].innerHTML = newBuyButtons[i].innerHTML;
        }
      if (isSecret == 'true'){
        console.log('Collection is secret')
      }else{
        console.log('Collection is NOT secret')
      }
    })
  }
}

window.renderButtons = renderProductBuyButtons;

/*
  Function to select All the anchor tags in the website that direct to Collection page
  And add available filtration to the href so it leads to the collection filtered by the "in stock"
  Products
*/
function updateAllCollectionsLinks(){
  // Select all anchor tags
  var anchorTags = Array.from(document.querySelectorAll("a"));

  // Filter anchor tags based on href containing "/collection/"
  var collection_anchor_tags = anchorTags.filter((anchorTag) => {
    /*
      To be sure that we select the link of "Collections" only not the "Products" links
      As the product Links has "/collections/" in it's url
    */
    if (anchorTag.href.indexOf('/collections/') !== -1 && anchorTag.href.indexOf('/products/') == -1) {
      return anchorTag.href
    }
  });

  collection_anchor_tags.forEach(tag => {
    var original_url = tag.href;
    if (original_url.indexOf('/vendors') !== -1) {
      // We have this special case in "Shop By Brand" page

      /*
        We need to add the filtration then the and (&) symbol 
        to filter by our query and the other query that available in the url
      */
      var filter_query = "filter.v.availability=1&";
      
      var filter_index = original_url.indexOf('q') // to get the index that we will start adding our query from it
      tag.href = original_url.slice(0, filter_index) + filter_query + original_url.slice(filter_index);
    }else if(original_url.indexOf('page=') !== -1 ) {

    }else if (tag.href.indexOf('filter.') === -1) {
      var filter_query = "?filter.v.availability=1";
      tag.href = original_url + filter_query
    }
  });
}

updateAllCollectionsLinks()